
























import Vue, { PropType } from 'vue'
import hljs from 'highlight.js'
import hljsCobol from 'highlightjs-cobol'
import { genericExtension } from '@/properties'
import { CodeEditorSegmegment } from '@/api/dto/CodeEditor';

hljs.registerLanguage('cobol', hljsCobol);

/**
 * 拡張子からhighlight.jsの言語名に変換
 * cf: <https://github.com/highlightjs/highlight.js/blob/main/SUPPORTED_LANGUAGES.md>
 */
const extensionToHljsLanguage = (ext: string): string => {
  if (genericExtension.includes(ext)) {
    return 'plaintext';
  }
  switch (ext) {
    case 'cob':
      return 'cobol';
    case 'exs':
      return 'elixir';
    case 'asm':
      return 'x86asm';
    case 'bas':
      return 'basic';
    default:
      return ext;
  };
}

export default Vue.extend({
  props: {
    theme: {
      type: String,
      required: true,
    },
    codeEditor: {
      type: Object as PropType<CodeEditorSegmegment>,
      required: true,
    },
    alertLines: {
      type: Array,
      required: false,
    },
  },
  filters: {
    fileNameOthersHide: function(fileName: string) {
      return fileName.replace(/その他$/, '');
    },
  },
  computed: {
    lineHtmls() {
      // remove prefixed dot
      const ext = (this.codeEditor as CodeEditorSegmegment).extension.slice(1);
      return this.codeEditor.text.map((code, i, arr) => {
        const { value } = hljs.highlight(code.code, {
          language: extensionToHljsLanguage(ext),
        });
        return { number: code.line, html: value };
      });
    },
  },
});
